import React from 'react'
import PropTypes from 'prop-types'
import BlockOptionsContainer from './BlockOptionsContainers'
import ImageBlockOptions from './ImageBlockOptions'
import TextBlockOptions from './TextBlockOptions'
import EmbedBlockOptions from './EmbedBlockOptions'
import ColorBlockOptions from './ColorBlockOptions'
import BlockEditOptions from './BlockEditOptions'
import BlockGroupingOptions from './BlockGroupingOptions'
import Menu from '../../../common/Menu'

export const BlockOptions = ({
  blocks,
  style,
  innerRef,
  placement,
  layer,
  outOfBoundaries
}) => {
  // Which sets of options to show

  // Can't group blocks that are in differnet sections
  const uniqueSections = () => {
    const sections = {}
    blocks.forEach(b => (sections[b.section] = true))
    return Object.keys(sections).length
  }
  const show = {
    grouping: blocks.length > 1 && uniqueSections() === 1,
    image: blocks.length === 1 && blocks[0].image,
    text: blocks.length === 1 && blocks[0].text,
    embed: blocks.length === 1 && blocks[0].embed,
    color: blocks.length === 1 && !blocks[0].image && !blocks[0].text && !blocks[0].embed
  }

  return (
    <Menu
      style={style}
      innerRef={innerRef}
      placement={placement}
      outOfBoundaries={outOfBoundaries}
      className="ignore-react-onclickoutside"
    >
      {show.image && <ImageBlockOptions block={blocks[0]} />}
      {show.text && <TextBlockOptions block={blocks[0]} />}
      {show.embed && <EmbedBlockOptions block={blocks[0]} />}
      {show.color && <ColorBlockOptions block={blocks[0]} />}
      <BlockEditOptions blocks={blocks} layer={layer} />
      {show.grouping && <BlockGroupingOptions blocks={blocks} />}
    </Menu>
  )
}

BlockOptions.propTypes = {
  blocks: PropTypes.array.isRequired,
  placement: PropTypes.string,
  layer: PropTypes.string
}

export default BlockOptionsContainer(BlockOptions)
